"use strict";

angular.module("customer")
.component("rebateIcon", {
    templateUrl: require("./rebate-icon.component.html")
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/rebate-icon/rebate-icon.component.js
// module id = 848
// module chunks = 0